import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import Global from '../../store/global-selectors';
import { sendShipmentNotification as sendShipmentNotificationAction } from '../../store/shipments/grid/shipments.grid.header.actions';
import { emptyArray } from 'ui-components/default-props/empty';

import style from './shared-classes.module.less';

const SendNotificationsButton = () => {
  const dispatch = useDispatch();
  const selectedFulfillmentIds = useSelector(Global.selectSelectedShipmentsSelectedShipmentIds) || emptyArray;
  const oneOrMoreShipmentSelected = selectedFulfillmentIds.length > 0;
  const disabled = !oneOrMoreShipmentSelected;
  const sendShipmentNotification = useCallback(
    () => dispatch(sendShipmentNotificationAction(selectedFulfillmentIds)),
    [selectedFulfillmentIds, dispatch],
  );

  return (
    <Button className={style['action-button']} disabled={disabled} onClick={sendShipmentNotification} theme='tertiary'>
      <FormattedMessage defaultMessage='Send Notifications' description='gridHeader.sendNotifications' id='0dFHP5' />
    </Button>
  );
};

export default SendNotificationsButton;
